import {z} from 'zod'

export enum MarketStatus {
  active = 'ACTIVE',
  inactive = 'INACTIVE',
}

const MarketUserSchema = z.object({
  gpid: z.string(),
  name: z.string(),
})

// MARK: - GET countries/onboarded

// EU returns `createdBy`/`updatedBy`, NA does not
export const OnboardedCountrySchema = z.object({
  id: z.number(),
  code: z.string(),
  name: z.string(),
  region: z.string().nullish(),
  status: z.nativeEnum(MarketStatus),
  createdBy: MarketUserSchema.nullish(),
  updatedBy: MarketUserSchema.nullish(),
  create_date: z.string(),
  update_date: z.string().nullish(),
  onboarded: z.boolean(),
  timezone: z.string().nullish(),
})

export const GetOnboardedCountriesRequestSchema = z.void()

export const GetOnboardedCountriesResponseSchema = z.object({
  success: z.boolean(),
  content: z.array(OnboardedCountrySchema),
})

export type OnboardedCountry = z.infer<typeof OnboardedCountrySchema>
export type GetOnboardedCountriesRequest = z.infer<typeof GetOnboardedCountriesRequestSchema>
export type GetOnboardedCountriesResponse = z.infer<typeof GetOnboardedCountriesResponseSchema>

// MARK: - GET countries/catalog

export const CatalogCountrySchema = z.object({
  code: z.string(),
  name: z.string(),
  timezone: z.string().nullish(),
})

export const GetCountriesCatalogRequestSchema = z.void()

export const GetCountriesCatalogResponseSchema = z.array(CatalogCountrySchema)

export type CatalogCountry = z.infer<typeof CatalogCountrySchema>
export type GetCountriesCatalogRequest = z.infer<typeof GetCountriesCatalogRequestSchema>
export type GetCountriesCatalogResponse = z.infer<typeof GetCountriesCatalogResponseSchema>

// MARK: - POST countries/onboarded

export const OnboardCountryRequestSchema = z.object({
  code: z.string().min(1),
})

export const OnboardCountryResultSchema = z.object({
  id: z.number(),
  code: z.string(),
  status: z.nativeEnum(MarketStatus),
  onboarded: z.boolean(),
})

// The GET endpoints return unwrapped payloads, but the POST response is not yet verified against the
// real backend (it was documented as `{success, data}`), so both shapes are accepted.
export const OnboardCountryResponseSchema = z.union([
  OnboardCountryResultSchema,
  z.object({success: z.boolean(), data: OnboardCountryResultSchema}),
])

export type OnboardCountryRequest = z.infer<typeof OnboardCountryRequestSchema>
export type OnboardCountryResult = z.infer<typeof OnboardCountryResultSchema>
export type OnboardCountryResponse = z.infer<typeof OnboardCountryResponseSchema>
